import { Businesses } from "@just-in-types";
import * as React from "react";
import { connect } from "react-redux";
import { reset, Reset } from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";
import Button from "./Button";

interface IResetButtonDispatchProps {
  onReset: Reset;
  site?: Businesses.Site;
}

interface IResetButtonStateProps {
  bg: string;
  languageStrings: IStrings;
  updating: boolean;
}

type ResetButtonProps = IResetButtonDispatchProps & IResetButtonStateProps;

class ResetButton extends React.Component<ResetButtonProps> {
  public render() {
    const { bg, onReset, languageStrings, updating } = this.props;

    let kioskUiButtonErrorColor: string;
    if (this.props.hasOwnProperty("site")) {
      kioskUiButtonErrorColor = this.props.site.kioskUiButtonErrorColor;
    }

    if (updating) {
      return null;
    } else {
      return (
        <Button bg={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : bg} onClick={() => onReset()}>
          {languageStrings.homeReset}
        </Button>
      );
    }
  }
}

const mapStateToProps = ({
  router: { languageStrings, rootPath },
  theme: {
    colors: { error: bg },
  },
  userTemp: { updating },
}: IState) => ({
  bg,
  languageStrings,
  rootPath,
  updating,
});

const mapDispatchToProps = {
  onReset: reset,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetButton);



// WEBPACK FOOTER //
// ./src/components/ResetButton.tsx